import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="min-h-[80vh] flex items-center justify-center bg-yellow-300 p-6">
    <div className="bg-white border-4 border-black shadow-[12px_12px_0px_rgba(0,0,0,1)] max-w-lg w-full p-10 text-center">
      <div className="bg-black text-white inline-block px-3 py-1 font-black uppercase tracking-widest text-xs mb-4">
        ERROR_404
      </div>
      <h1 className="text-7xl md:text-9xl font-black tracking-tighter leading-none mb-3">404</h1>
      <p className="text-lg font-mono opacity-70 mb-6">This page is in the void.</p>
      <Link
        to="/"
        className="inline-block bg-yellow-400 text-black px-8 py-4 font-black uppercase border-4 border-black shadow-[4px_4px_0px_black] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all"
      >
        ← Return Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
